import get from "lodash/get";

import { IRootState } from "../../rootReducer";
import { IUser } from "../../../types/auth/IUser";

export function getUser(state: IRootState): IUser | null {
  return get(state, ["session", "activeUser"]);
}

export function getIsAnonymous(state: IRootState): boolean | undefined {
  return get(state, ["session", "activeUser", "isAnonymous"]);
}
